/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Cat_Limited_OnlineInputs */



/**
* | output |
* | --- |
* | "Limited Online" |
*
* @param {Rankings_Cat_Limited_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_cat_limited_online = /** @type {((inputs?: Rankings_Cat_Limited_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Cat_Limited_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Limité en ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Limited Online")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Limited Online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Limited Online")
	return /** @type {LocalizedString} */ ("Limited Online")
});